module.exports = __webpack_public_path__ + "5d0cd34af38fd69873f8ab89ffac4c3f.svg";